/**
 * Where the guard (./guard) leads a session the API refused for an account step (spec
 * 2026-09-30 akun-dan-keamanan 6): the step's screen, and back to where it was afterwards.
 * Never away from unsaved work (plan 6 ruling, 2026-10-01): like the idle lock, the step
 * waits while a form holds unsaved changes and opens as soon as the form is clean. DOM-free
 * so the tests import it.
 */
import type { LangkahAkun } from '@satu/shared'

/** The screen of each account step (the sign-in screens under /masuk). */
export const LAYAR_LANGKAH: Readonly<Record<LangkahAkun, string>> = {
  ganti_sandi: '/masuk/sandi-awal',
  dua_langkah: '/masuk/dua-langkah',
}

/** The step's screen, or null to stay: none asked for, or a form still unsaved. */
export function arahLangkahAkun(
  langkah: LangkahAkun | null,
  adaPerubahanBelumDisimpan: boolean,
): string | null {
  if (langkah === null || adaPerubahanBelumDisimpan) return null
  return LAYAR_LANGKAH[langkah]
}
